exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".schadenfaelletabs .nav-tabs{padding-left:18px;margin-top:10px;margin-left:-8px;margin-right:-8px}@media(min-width:992px){.schadenfaelletabs .nav-tabs{padding-left:245px;margin-top:27px}.schadenfaelletabs .tab-pane{padding:30px}}@media(min-width:1025px){.schadenfaelle-list-view__betroffene{padding:30px 150px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/schadenfaelle/schadenfaelle.module.scss
// module id = cixw
// module chunks = 0